
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
<path d="M7.9999 7.10313C9.68271 7.10313 11.0468 5.73906 11.0468 4.05625C11.0468 2.37344 9.68271 1.00938 7.9999 1.00781C6.31709 1.00781 4.95303 2.37188 4.95146 4.05469V4.05625C4.95303 5.73906 6.31709 7.10313 7.9999 7.10313ZM2.85928 9.15469C2.25771 10.6766 1.6499 14.9922 1.6499 14.9922H6.82646L5.27021 7.86406C4.33271 7.86406 3.46084 7.63281 2.85928 9.15469ZM7.9999 7.86406L6.53115 9.91562L7.6874 14.9922H8.3124L9.46865 9.91562L7.9999 7.86406ZM13.1405 9.15469C12.539 7.63281 11.6671 7.86406 10.7296 7.86406L9.17334 14.9922H14.3499C14.3499 14.9922 13.7421 10.6766 13.1405 9.15469ZM12.6421 11.7906H10.8265V11.3859H12.6421V11.7906Z" fill="currentColor"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Saler',
    }) as DefineComponent
    </script>
    